// extracted by mini-css-extract-plugin
module.exports = {"app":"_31s2f","drop":"_2NQIN","option-pair":"_1hoMi","optionPair":"_1hoMi","horizontal":"GWMRj","vertical":"_1x1HP","app-loader":"pVSVZ","appLoader":"pVSVZ"};